import React from "react";
import "./QRPayment.css";

const QRPaymentError = (props) => {
  const isInIframe = window.self !== window.top;

  return (
    <div className="qr-container">
      <h2 className="titleQR">⚠️ Error al Generar el Código QR para el Pedido {props.id_pedido}</h2>
      <div className="instructions-qr">
        <div className="qr-section" style={{ width: "100%" }}>
          <img
            src="/img/error-qr.png"
            alt="Error QR"
            className="qr-image"
            style={{ maxWidth: 220 }}
          />
          <p style={{ marginTop: 16, fontSize: "16px", color: "#FF7E5F" }}>
            No pudimos generar el código QR para tu pedido.
          </p>
          <p>
            Por favor, revisa que tu información sea correcta o{" "}
            <strong>recarga esta página</strong> para intentarlo nuevamente.
          </p>
          <button
            className="btn download"
            onClick={() => {
              const isInIframe = window.self !== window.top;
              if (isInIframe) {
                window.top.location.reload();
              } else {
                window.location.reload();
              }
            }}
            style={{ marginTop: 20 }}
          >
            Reintentar
          </button>
        </div>
      </div>
    </div>
  );
};

export default QRPaymentError;
